export default __webpack_public_path__ + "img/63bb802bc605c329fe9534bb2b583e58.svg";